
import { useStore } from '@/store/useStore';

/**
 * @deprecated Please use `useStore` directly. This is a temporary alias for backward compatibility.
 */
export const usePriceStore = useStore;
